import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import axios from "../../utils/axios";
// import Swal from 'sweetalert2'
import Moment from "moment";
//import { setUserSession } from '../../utils/Common';
import DataTable from "react-data-table-component";
import HEAD from "../../component/header";
import SIDE from "../../component/navbar";
import { getToken } from "../../utils/Common";
import _ from "lodash";

function Request() {
  const FileDownload = require("js-file-download");

  const history = useHistory();
  const token = getToken();
  const headers = {
    Authorization: `Bearer ${token}`,
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  };
  // Session
  const session = localStorage.getItem("user");
  const udeptID = JSON.parse(session).dept_id;
  const hcode = JSON.parse(session).hotel_id;
  const [loading, setLoading] = useState(true);

  const downloadPurchaseRequestWaiting = () => {
    axios
      .get(
        `/api/generate/excel/report/waiting/request/${hcode}/${udeptID}`,
        { responseType: "blob" },
        { headers: headers }
      )
      .then(function (response) {
        //   console.log(response.data);
        FileDownload(response.data, "purchase_request.xlsx");
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // Var
  const [purchaseRequest, setPurchaseRequest] = useState([]);
  const [hotelList, setHotelList] = useState([]);

  const getListHotelbyUser = async () => {
    try {
      const response = await axios.post(
        "/api/list/hotel/by-user",
        { hcode },
        { headers }
      );
      setHotelList(response.data);
    } catch (error) {
      console.log("Error API Hotel: ", error);
    }
  };

  //const ExpandedComponent = ({ data }) => <pre>{data.title}</pre>;

  const columns = [
    {
      name: "PP No.",
      width: "200px",
      wrap: true,
      selector: (row) => row.nomer,
    },
    {
      name: "Origin",
      wrap: true,
      cell: (row) => (
        <div>
          <b>For Hotel</b> : {row.nm_hotel}
          <br />
          <b>From Department: </b> {row.nm_department}
        </div>
      ),
    },

    {
      name: "Created",
      cell: (row) => Moment(row.created_at).format("LLL"),
    },
    {
      name: " Need For",
      cell: (row) => Moment(row.date_need).format("LL"),
    },
    {
      name: "Status",
      wrap: true,
      cell: (row) => (
        <>
          <i>{row.statusPR}</i>
        </>
      ),
    },
    {
      name: "",
      width: "50px",
      cell: (row) => (
        <div onClick={() => history.push(`/detail/proposal/${row.id_pp}`)}>
          <i class="bi bi-search"></i>
        </div>
      ),
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.stts_pp >= 1 && row.stts_pp <= 3,
      style: {
        backgroundColor: "rgba(80, 255, 71, 0.2)",
        color: "black",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
    {
      when: (row) => row.stts_pp >= 4 && row.stts_pp < 8,
      style: {
        backgroundColor: "rgba(80, 0, 255, 0.2)",
        color: "black",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
    {
      when: (row) => row.stts_pp >= 9 && row.stts_pp <= 11,
      style: {
        backgroundColor: "rgba(248, 148, 6, 0.2)",
        color: "black",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
  ];

  // const customStyles = {
  //   headCells: {
  //     style: {
  //       fontSize: "13px",
  //     },
  //   },
  //   cells: {
  //     style: {
  //       fontSize: "11px",
  //     },
  //   },
  // };

  // Search
  const [filtertext, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const filteredItems = purchaseRequest.filter((search) =>
    Object.values(search)
      .join("")
      .toLowerCase()
      .includes(filtertext.toLowerCase())
  );

  const handleClear = () => {
    if (filtertext) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const getPurchaseRequestWaiting = async (hotel) => {
    setLoading(true);
    try {
      let code = hotel ? hotel : hcode; // Use hotel if available, otherwise fallback to hcode
      const response = await axios.post("/api/waiting/request",{ hcode: code, udeptID },{ headers });
      console.log(response.data)
      setPurchaseRequest(Object.values(response.data).flatMap((arr) => arr));
    } catch (error) {
      console.log("Error getAPIListPPW: ", error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedGetPurchaseRequestWaiting = _.debounce(
    getPurchaseRequestWaiting,
    100
  );
  const debouncedGetListHotelbyUser = _.debounce(getListHotelbyUser, 100);

  useEffect(() => {
    debouncedGetPurchaseRequestWaiting();
    debouncedGetListHotelbyUser();
  }, []);

  return (
    <>
      <HEAD />
      <SIDE />

      <main id="main" className="main">
        <div className="pagetitle">
          <h6
            className="mb-0"
            style={{ fontWeight: "bold", marginLeft: "7px" }}
          >
            Purchase Request
          </h6>
          <nav>
            <ol className="breadcrumb mt-1 mb-2 ms-2">
              <li
                className="breadcrumb-item"
                style={{ cursor: "pointer", fontSize: "13px" }}
                onClick={() => history.push("/dashboard")}
              >
                Home
              </li>
              <li style={{ fontSize: "13px" }} className="breadcrumb-item ">
                Purchase Request
              </li>
              <li
                style={{ fontSize: "13px" }}
                className="breadcrumb-item active"
              >
                Waiting
              </li>
            </ol>
          </nav>
        </div>

        <section>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row p-0 pb-2 mb-2 mt-3">
                    <div className="col-1 pe-0">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-warning"
                        style={{ marginRight: "12px" }}
                        onClick={() => debouncedGetPurchaseRequestWaiting()}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-warning"
                        style={{ marginRight: "1%" }}
                        onClick={() => downloadPurchaseRequestWaiting()}
                      >
                        <i className="bi bi-printer"></i>
                      </button>
                    </div>

                    <div className="col-7 ps-1">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search"
                        onChange={(e) => setFilterText(e.target.value)}
                        onClear={() => handleClear}
                        filtertext={filtertext}
                      />
                    </div>

                    <div className="col-4">
                      <select
                        id="hotelSelect"
                        className="form-select form-select-sm"
                        onChange={(e) =>
                          debouncedGetPurchaseRequestWaiting(e.target.value)
                        }
                      >
                        <option>Group By Hotel</option>
                        {hotelList.map((x, t) =>
                          x.map((v, k) => (
                            <option key={k} value={v.id_hotel}>
                              {v.code_hotel} - {v.nm_hotel}
                            </option>
                          ))
                        )}
                      </select>
                    </div>
                  </div>

                  {loading ? (
                    <div
                      className="d-flex flex-column justify-content-center align-items-center"
                      style={{ minHeight: "100px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="sr-only"></span>
                      </div>
                      <div style={{ marginTop: "10px" }}>Loading...</div>
                    </div>
                  ) : (
                    <div className="row">
                      <DataTable
                        columns={columns}
                        data={filteredItems}
                       
                        fixedHeader
                        fixedHeaderScrollHeight="460px"
                        pagination
                        conditionalRowStyles={conditionalRowStyles}
                        // expandableRows
                        // expandableRowsComponent={ExpandedComponent}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Request;
